<ng-container *ngIf="isInitialized">
  <ul *ngIf="items && items.length > 0" class="widget__list" style="margin-bottom: 15px;">
    <li *ngFor="let slide of items | paginate: { id: 'slides', itemsPerPage: pagination.pageSize, currentPage:
      p, totalItems: pagination.total }"
      class="widget__list__carousel-item">
      <div class="widget__list__carousel-img" [ngStyle]="getFileStyle(slide.file)">
        <div *ngIf="null === slide.file" class="widget__list__carousel-name">{{getClaim(slide) + ' ' +
          getSubClaim(slide)}}</div>
        <span class="widget__list__carousel-actions">
          <a [routerLink]="['slides/edit', slide.id]" class="widget__list__actions__link widget__list__actions__link--edit">
            <i class="ico-edit"></i>
          </a>
          <a [routerLink]="{ outlets: { 'modal': ['delete', slide.id] } }" [queryParams]="{header:'Opravdu chcete smazat slide ' + getClaim(slide) + ' ' + getSubClaim(slide) + '?', body: 'Slide již nebude možné obnovit.'}"
            class="widget__list__actions__link widget__list__actions__link--remove">
            <i class="ico-remove"></i>
          </a>
        </span>
      </div>
    </li>
  </ul>
  <pagination-controls *ngIf="pagination.total > pagination.pageSize" id="slides" (pageChange)="pageChanged($event)" maxSize="9"
    directionLinks="true" autoHide="true" previousLabel="" nextLabel="" screenReaderPaginationLabel="Pagination"
    screenReaderPageLabel="Stránka" screenReaderCurrentLabel="Jste na stránce">
  </pagination-controls>
</ng-container>

<div *ngIf="!isInitialized" class="widget__content loading"></div>

<swb-no-data *ngIf="items && items.length === 0 && isInitialized"></swb-no-data>